import(/* webpackMode: "eager" */ "/home/runner/work/siwi/siwi/node_modules/.pnpm/next@15.5.4_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/siwi/siwi/node_modules/.pnpm/next@15.5.4_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Download"] */ "/home/runner/work/siwi/siwi/src/components/Download.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/home/runner/work/siwi/siwi/src/components/LanguageSwitcher.tsx");
